import { getAPIHostnameForUIDomain } from 'libs/end-to-end/src/domain-utils';

// The DefinePlugin will sometimes make it difficult to find our PLACEHOLDER values in the codebase,
// which we need to replace at build time.
// @ts-expect-error - This is a placeholder for the actual environment variables
globalThis['s2EnvVarsWithoutOptimizingOutForRspack'] = {
  OA_EN: process.env.OA_EN,
  DS_EN: process.env.DS_EN,
  DS_AB: process.env.DS_AB,
  SSO_ENABLED: process.env.SSO_ENABLED,
  CALLBACK_LOGIN_URI: process.env.CALLBACK_LOGIN_URI,
  CALLBACK_LOGOUT_URI: process.env.CALLBACK_LOGOUT_URI,
  UI_ENVIRONMENT_NAME: process.env.UI_ENVIRONMENT_NAME,
  UI_SANDBOX_NAME: process.env.UI_SANDBOX_NAME,
  SNTY_ON: process.env.SNTY_ON,
  SNTY_DSN_UI: process.env.SNTY_DSN_UI,
  SNTY_PROP_TRGTS: process.env.SNTY_PROP_TRGTS,
  S2_RH: process.env.SNTY_RELEASE,
  SNTY_ENV: process.env.SNTY_ENV,
  NODE_ENV: process.env.NODE_ENV,
};
const varsForReading: Record<string, string | undefined> =
  // @ts-expect-error - This is a placeholder for the actual environment variables
  globalThis['s2EnvVarsWithoutOptimizingOutForRspack'];

export const uiEnvironment = {
  openaiEnabled: varsForReading.OA_EN === 'true',
  ssoEnabled: varsForReading.SSO_ENABLED === 'true',
  callbackLoginUri:
    varsForReading.CALLBACK_LOGIN_URI || 'http://localhost:8081/callback-login',
  callbackLogoutUri:
    varsForReading.CALLBACK_LOGOUT_URI ||
    'http://localhost:8081/callback-logout',
  uiEnvironmentName: varsForReading.UI_ENVIRONMENT_NAME || 'dev',
  uiSandboxName: varsForReading.UI_SANDBOX_NAME || '',
  sentryEnabled: varsForReading.SNTY_ON === 'true',
  sentryDsnUi: varsForReading.SNTY_DSN_UI || '',
  sentryTracePropagationTargets: varsForReading.SNTY_PROP_TRGTS || 'localhost',
  sentryRelease: varsForReading.SNTY_RELEASE || '',
  sentryEnvironmentName: varsForReading.SNTY_ENV || 'dev',
};

// We do not want to accidentally rspack these variables, so we use a global variable
// that is not optimized out by rspack.
const getOverrideApiBaseUrlFromProcessGlobals = (): string | undefined => {
  if (process.env.OVERRIDE_API_BASE_URL) {
    return process.env.OVERRIDE_API_BASE_URL;
  }

  // Storybook makes it is very challenging to access OVERRIDE_API_BASE_URL, so we are using this to workaround it.
  if ('STORYBOOK_HOOKS_CONTEXT' in globalThis && 'STORIES' in globalThis) {
    return 'http://localhost:1234/api';
  }

  return undefined;
};

export const getApiBaseUrl = () => {
  // This override is only used for development/vitest purposes.
  const overrideApiBaseUrl = getOverrideApiBaseUrlFromProcessGlobals();

  if (overrideApiBaseUrl) {
    return overrideApiBaseUrl;
  }

  const { apiHostname } = getAPIHostnameForUIDomain({
    uiHostname: window.location.origin,
  });

  return `${apiHostname}/api`;
};

export const isLocalEnv = () => {
  return varsForReading.NODE_ENV !== 'production';
};
